import { QrAssets } from '../models/qrAssets';

export const QrAssetsEntity = ({
  qr = '',
}: QrAssets): Readonly<QrAssets> => {
  return Object.freeze({
    qr,
  });
}
